import React from "react";
import Form from "react-bootstrap/Form";
import "../scss/BeelditSwitchInput.css";

interface BeelditRadioInputProps {
  id: string;
  required: boolean;
  readonly: boolean;
  disabled: boolean;
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  onBlur: (id: string, value: boolean) => void;
  uiSchema: any;
}

const BeelditRadioInput: React.FC<
  BeelditRadioInputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
  id,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  uiSchema,
  ...rest
}) => {
  const radioName = uiSchema?.["ui:options"]?.["radio-name"] || id;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
    if (onBlur) onBlur(id, e.target.checked);
  };

  // Normaliza props: filtra no estándar (RJSF) y mapea autofocus -> autoFocus
  const { autofocus, type: _ignoredType, ...restIncoming } = rest as any;
  const blocked = new Set([
    "custom",
    "autofocus",
    "type",
    "hideLabel",
    "hideError",
    "formContext",
    "rawErrors",
    "schema",
    "uiSchema",
    "registry",
    "idSchema",
    "errorSchema",
    "formData",
  ]);
  const filtered = Object.fromEntries(
    Object.entries(restIncoming).filter(([key]) => !blocked.has(key))
  );
  const restProps = {
    ...filtered,
    ...(autofocus ? { autoFocus: true } : {}),
  } as any;

  return (
    <Form.Check
      type="radio"
      id={id}
      name={radioName}
      label={label}
      checked={!!value}
      required={required}
      readOnly={readonly}
      disabled={disabled}
      onChange={handleChange}
      className="ms-2 d-flex align-items-center gap-2"
      {...restProps}
    />
  );
};

export default BeelditRadioInput;
